import { Component, Input } from '@angular/core';

import { Representante } from '../representante';

@Component({
    selector: 'sgt-representante-configuracao',
    templateUrl: './representante-configuracao.component.html',
    styleUrls: ['./representante-configuracao.component.less']
})
export class RepresentanteConfiguracaoComponent {
    @Input() entity: Representante;
}
